(function() {
    angular
        .module("app")
        .directive("wmcanvas", wmcanvas)

    wmcanvas.$inject = [
        "$rootScope",
        "$stateParams",
        "messageBoardsService"
    ]

    function wmcanvas(
        $rootScope,
        $stateParams,
        messageBoardsService
    ){
        return {
            restrict: "E",
            replace: true,
            templateUrl: "app/directives/wmcanvas.view.html",
            link: function(scope, elm, attrs) {

                let messageBoardID = $rootScope.graphicMessageBoardID

                // if ($stateParams.hasOwnProperty(message_board_id) && $stateParams.message_board_id.split(",").length == 1) {
                //     messageBoardID = $stateParams.message_board_id
                // } else if ($rootScope.graphicMessageBoardID) {
                //     messageBoardID = $rootScope.graphicMessageBoardID
                // }

                //Get Message Board
                if(messageBoardID > 0) {
                    messageBoardsService.getMessageBoard(messageBoardID, function(data) {
                        scope.messageBoard = data

                        if(scope.messageBoard.num_colors != 5) {
                            $(".full_color_options").hide()
                        }

                        WMCanvas.InitiateWancoDesignTool(false, scope.messageBoard.width_pixels || 72, scope.messageBoard.height_pixels || 40, scope.messageBoard.max_pages_per_message || 3, false)
                    })
                } else {
                    WMCanvas.InitiateWancoDesignTool(false, 72, 40, 3, false)
                    $(".full_color_options").hide()
                }

                $("#messageBar").remove()
                $("#messageBarTmp").attr("id", "messageBar")
                $("#NewWancoTool").show()

                //prevent the enter key from causing form submission because
                //we actually have two submit buttons and its not clear what the
                //user would want by pressing enter, so he has to click a button.
                // 2022-02-12 - Disabled because it was apparently not needed anymore and interfered with V2 Message Create (blocked enter key)
                // $(window).keydown(function(event){
                //     if(event.keyCode == 13) {
                //         event.preventDefault()
                //         return false
                //     }
                // })
            }
        }
    }
})()
